import {createStyles, Theme} from "@material-ui/core";
import {buttonContained, greyInput, primaryColor, secondaryColor, styleColors, typography} from "src/main.style";

export const sharedMiscStyle = (theme: Theme) => createStyles({
  greyInput,
  buttonContained,
  root: {
    padding: theme.spacing(3.25, 2.5, 2.5),

    '& > *': {
      boxSizing: 'border-box',
    }
  },
  notesList: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',
    flexFlow: 'wrap',
    // gap: theme.spacing(3.75),
    position: 'relative',
  },
  notesList2: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',
    flexFlow: 'wrap',
    // gap: theme.spacing(3.75),
    position: 'relative',
  },
  expandMiddle : {
      margin: '-26px 0px',
      display: 'flex',
      alignSelf: 'center',
      userSelect: 'none',
  },
  cardPadding : {
    padding:'15px 0px',
    width:'100%',
    maxWidth: '450px',
  },
  card: {
    display: 'flex',
    padding: theme.spacing(3.25, 2.5, 2.5),
    flexDirection: 'column',
    gap: theme.spacing(2.75),
    boxShadow: theme.shadows[4],
    borderRadius: '14px',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    width: '100%',
    userSelect: 'none',
    minWidth: '320px',
    maxWidth: '420px',
    position: 'relative',
    border: `1px solid ${styleColors.blackAlpha23}`,
    transition: 'all 0.25s',
    zIndex: 1,
  },
  cardTop: {
    width: '100%',
    display: 'flex',
    maxWidth: '100%',
    alignItems: 'center',
    justifyContent: 'flex-start',
    userSelect: 'none',
    flexDirection: 'row',
  },
  avatar: {
    width: '50px',
    height: '50px',
    borderRadius: '120px',
  },
  experiment: {
    padding: '16px',
    top: '-16px',
    right: '-16px',
    position: 'relative',
    userSelect: 'none',
    alignSelf: 'start',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  topMiddle: {
    position:'relative',
    userSelect: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1,
    paddingLeft: '10px',
  },
  titleInput: {
    margin: '4px 2px 4px 1px',
    textOverflow:'ellipsis',
    flex: 1,
    color: theme.palette.common.black,
    borderWidth: 0,
    outlineWidth: 0,
    padding: '3px 0px',
    ...typography.input,
    fontSize: '1.125rem',
    minWidth: '100%',
    maxWidth:'100%',
    width:'100%',
  },
  rowInput:{
    minWidth: '150px',
    maxWidth: 'unset',
    width: 'unset',
    padding: '3px 0px',
  },
  dragButton: {
    fontSize: '18px',
    padding: 0,
    margin: 0,
    width: 'auto',
    height: 'auto',
    minWidth: 'unset',
  },
  name: {
    fontSize: '18px',
    lineHeight: '22px',
    fontWeight: 600,
    color: styleColors.greyDark2,
    marginLeft: '6px',
  },
  iconStyle: {
    width: '14px',
    height: '14px',
    padding: '2px',
    userSelect: 'none',
    fill: theme.palette.common.white,
    borderRadius: '18px',
    backgroundColor: theme.palette.secondary.main,
  },
  list: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    userSelect: 'none',
  },
  listValue: {
    flex: 1,
    ...typography.input,
    color: theme.palette.common.black,
    userSelect: 'text',
    WebkitUserSelect: 'text',
    WebkitTouchCallout: 'default',
    cursor: 'text',
    /* Inherit the card surface behind the input so it matches in both
       themes — input elements default to white otherwise. */
    backgroundColor: 'transparent',
    fontSize: '0.9375rem',
    borderWidth: 0,
    outline: 'none',
    padding: '10px 0px',

    // Standard placeholder
    '&::placeholder': {
      ...typography.input,
      color: theme.palette.common.grey,
    },
  },
  cardBottom: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(0.25),
  },
  cardButtonActions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    userSelect:'none',
    alignItems: 'center',
    gap: theme.spacing(1),
    position: 'relative',
    maxWidth: '100%',
  },
  avatars: {
    flexDirection: 'row',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'flex-Start',
    gap: theme.spacing(0.5),
  },
  helper: {
    margin: '100px 40px',
    textAlign: 'center',
    color: styleColors.greyMedium2,
  },
  value: {
    color: styleColors.greyDark2,
    fontSize: '16px',
    lineHeight: '18px',
    fontWeight: 400,
    alignSelf: 'flex-end',
    display: 'flex',
    textAlign: 'right',
    minWidth: '120px',
    borderWidth: 0,
    letterSpacing: 'normal',
    wordSpacing: 'normal',
    fontFamily: "'Metropolis', 'Helvetica', 'Arial', 'sans-serif'",
    resize: 'none',
  },
  listBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    // gap: theme.spacing(1.25),
    userSelect:'none',
  },
  listHolder: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    scrollbarWidth: 'none',
    WebkitOverflowScrolling: 'touch',
    scrollSnapType: 'x mandatory',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      display: 'none',
  },
  },
  listRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    userSelect:'none',
    scrollSnapAlign: 'start',
    minWidth: 'calc(100% + 80px)',
    maxHeight: '50px',
    transition: 'all 0.3s',
  },
  listRowContent :  {
    minWidth: '100vw',
    maxWidth: '100vw',
    display: 'flex',
    padding: '0px 23px',
    boxSizing: 'border-box',
  },
  listRowButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  listRowErase: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: primaryColor,
    color: styleColors.white,
    minWidth:'80px',
    scrollSnapAlign: 'start',
    justifyContent: 'center',
    minHeight: '100%',
  },
  listRowDrag: {
    padding: '0px 10px',
    scrollSnapAlign: 'start',
    display: 'flex',
    alignSelf: 'center',
  },
  checkButtonRoot: {
    height: '30px',
    width: '30px',
    display: 'flex',
    alignItems: 'center',
    userSelect: 'none',
    justifyContent: 'center',
    margin: '6px 0px 6px 6px',
    color: theme.palette.common.white,
  },
  addNewButton: {
    padding: 0,
  },
  expand: {
    marginRight: '40px',
    transform: 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(0deg)',
  },
  seenBy: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(0.25),
    ...typography.placeholder,
    fontSize: '0.666666rem',
    fontStyle: 'normal',
    fontWeight: 400,
    userSelect:'none',
    lineHeight: 'normal',
    color: styleColors.greyMedium2,
  },
  speedDial: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    position: 'sticky',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    alignItems: 'flex-end',
    zIndex: 10,
  },
  speedDialActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  speedDialAction: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  speedDialActionLabel: {
    boxShadow: theme.shadows[4],
  },
  speedDialActionButton: {
    boxShadow: theme.shadows[4],
    width: '56px',
    height: '56px',
  },
  fabAction: {
    userSelect: 'none',
    boxShadow: theme.shadows[4],
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  menuPaper: {
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[4],
  },
  menuList: {
    padding: theme.spacing(1, 0),
  },
  menuListItem: {
    ...typography.input,
  },
   FAB : {
    color: '#FFFFFF',
    width: '62px',
    cursor: 'pointer',
    height: '62px',
    display: 'flex',
    overflow: 'hidden',
    fontSize: '24px',
    boxSizing: 'border-box',
    transition: 'all 0.2s',
    alignItems: 'center',
    userSelect: 'none',
    borderRadius: '50%',
    justifyContent: 'center',
    boxShadow: `0px 3px 30px ${styleColors.fabShadow}`,
    backgroundColor: primaryColor,
    webkitUserSelect: 'none',
    position: 'absolute',
    bottom: '100px',
    right: '20px',
    zIndex: 100,
  },
  FABcontent : {
    backgroundColor: secondaryColor,
    maxWidth: '50px',
    minWidth: '50px',
    minHeight: '50px',
    maxHeight: '50px',
    borderRadius: '100px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  FABtext: {
    position: 'absolute',
    bottom: '244px',
    zIndex: 3,
    right: 'calc(-200% + 88px)',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    alignItems: 'center',
    pointerEvents: 'none',
    opacity: 0,
    transition: '300ms',
    transitionDelay: '400ms',
    userSelect: 'none',
    boxShadow: theme.shadows[4],
  },
  cancelFab: {
    width: '40px',
    height: '40px',
    bottom: '41px',
    right: 'calc(-200% + 31px)',
    backgroundColor: styleColors.white,
    color: styleColors.greyDark2,
    userSelect: 'none',
    transform: 'rotate(45deg)',
    boxShadow: theme.shadows[4],
  },
  fabIcon: {
    zIndex: 2,
    userSelect: 'none',
    /* FAB background is brand coral in both themes — icon must always
       be actual white, not styleColors.white (which flips dark). */
    fill: '#FFFFFF',
    width: '36px',
    height: '36px',
  },
  helpText : {
    color: styleColors.greyMedium1, 
    fontSize: '17px',  
    textShadow: `0px 1px 0px ${styleColors.whiteOverlay28}, 0px -1px 0px ${styleColors.blackInset33}`
  },
  shareNoteListItem : {
    display: 'flex',
    minHeight: '80px',
    maxHeight: '80px',
    transition: 'all 0.2s',
    overflow: 'hidden',
  },
  shareNoteListItemUnseen : {
    '& $shareNoteListItemTitle, & $shareNoteListItemSeenBy': {
      color: primaryColor,
    },
  },
  shareNoteListItemIcon : {
    display: 'flex',
    minHeight: '80px',
    maxHeight: '80px',
    minWidth: '100px',
    maxWidth: '100px',
    // alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '12px',
    
  },
  shareNoteListItemBody : {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    overflow: 'hidden',
    justifyContent: 'center',
  },
  shareNoteListItemTopRow : {
    display: 'flex',
    // paddingTop: '6px',
    alignItems: 'baseline',
  },
  shareNoteListItemBottomRow : {
    display: 'flex',
    alignItems: 'baseline',
    gap: '8px',
    paddingTop: '10px',
    maxWidth: 'calc(100% - 18px)',
  },
  shareNoteListItemTitle : {
    flexGrow:1,
    fontSize: '16px',
    fontWeight: 500,
    paddingTop: '6px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  shareNoteListItemTime : {
    display: 'flex',
    paddingRight: '18px',
    fontWeight: 300,
    fontSize: '14px',
    color:styleColors.greyDark1,
    paddingLeft: '4px',
    textWrap: 'nowrap',
  },
  shareNoteListItemMessage : {
    flex: 1,
    minWidth: 0,
    minHeight: '18px',
    lineHeight: '18px',
    fontWeight:300,
    // maxHeight:'40px',
    color:styleColors.greyDark1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '14px',
    whiteSpace: 'nowrap',
    // '-webkit-line-clamp': 2,
    // '-webkit-box-orient': 'vertical',
    // display: '-webkit-box',
  },
  shareNoteListItemSeenBy : {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    whiteSpace: 'nowrap',
    fontSize: '10px',
    color: styleColors.blackAlpha63,
    gap:'1px',
    justifyContent: 'flex-end',
  },
  icon : {
    minHeight: '56px',
    maxHeight: '56px',
    minWidth: '56px',
    maxWidth: '56px',
    backgroundColor: secondaryColor+"54",
    borderRadius:'100px',
    boxSizing: 'border-box',
    display: 'flex',
    placeContent: 'center',
    overflow:'hidden',
    position: 'relative',
    border:`1px solid ${styleColors.blackAlpha18}`,
  },
  imageIcon : {
    width: '100%',
    height: '100%',
    objectFit: 'cover',     /* scales & crops image to fill box */
    objectPosition: 'center', /* centers the crop on the image’s middle */
    display: 'block',        /* remove inline‐img whitespace */
  },
  sharedNoteList : {
    display: 'flex',
    paddingTop: '12px',
    borderRadius: '32px 32px 0px 0px',
    maxWidth: '100vw',
    minWidth: '100vw',
    overflowX: 'hidden',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    overscrollBehaviorY: 'contain',
    scrollPaddingBottom: 'calc(80px + env(safe-area-inset-bottom, 0px))',
    flexDirection: 'column',
    paddingBottom:'calc(80px + env(safe-area-inset-bottom, 0px))',
    boxSizing: 'border-box',
    backgroundColor: styleColors.white,
    flex:1,
    minHeight: 0,
    boxShadow: `0px -1px 23px ${styleColors.blackAlpha23}`,
    marginTop:'23px',
    height:'calc(100% - 90px)',
    maxHeight:'calc(100% - 90px)',
    transition: 'all 0.3s',
  },
  sharedNotePane: {
    minHeight:'0%',
    maxHeight:'0%',
    height:'0%',
    position: 'absolute', 
    bottom:0, 
    left: 0, 
    zIndex: 2, 
    width: '100%', 
    display:'flex', 
    flexDirection:'column',
    overflow: 'hidden',
    transition:'all 0.3s',
  },
  sharedNotePaneTop: {
    width: '100%',
    paddingTop: '28px',
    paddingBottom: '24px',
    position: 'absolute',
    boxSizing: 'border-box',
    marginTop: '4px',
    display: 'flex',
    justifyContent: 'center',
    touchAction: 'pan-y',
    zIndex: 3,
  },
  sharedNotePaneTopContent: {
    minWidth: '120px',
    minHeight: '3px',
    backgroundColor: styleColors.lightGreyOverlay,
    borderRadius: '4px',
  },
  sharedNoteBottomBar : {
    position: 'absolute',
    bottom: '74px',
    left: '0px',
    width: '100%',
    backgroundColor: styleColors.white,
    display: 'flex',
    justifyContent: 'center', 
    padding:'20px', 
    maxHeight: '70px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    transition: 'all 0.3s',
  },
  bounceRight: {
    animation: '$bounceRight 0.6s ease',
  },
  
  '@keyframes bounceRight': {
    '0%': { transform: 'translateX(0)' },
    '20%': { transform: 'translateX(6px)' },
    '40%': { transform: 'translateX(-4px)' },
    '60%': { transform: 'translateX(3px)' },
    '80%': { transform: 'translateX(-2px)' },
    '100%': { transform: 'translateX(0)' },
  },

  aiAnalyzingBackground : {
    background: `conic-gradient(from 90deg at 50% 50%, ${styleColors.greyDark1}, ${styleColors.white}, ${styleColors.greyDark1}, ${styleColors.white}, ${styleColors.greyDark1})`,
    animation: `$rotateGradient 2s infinite linear`,
    boxShadow: '0px 3px 30px '+secondaryColor+'ad',
    backgroundSize: '124px 124px',
  },
  '@keyframes rotateGradient' : {
    '0%' :{
      backgroundPosition: '0px 0px',
    },
   '50%': {
      backgroundPosition: '62px 62px',
    },
    '100%' : {
      backgroundPosition: '0px 0px',
    }
  },
  workingNeonPill: {
    height: '26px',
    minWidth: '80px',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '999px',
    fontWeight: 700,
    fontSize: '1rem',
    letterSpacing: '0.05em',
    position: 'relative',
    color: styleColors.white,
    zIndex: 2,
    overflow: 'hidden',
    padding: '0 18px',
    userSelect: 'none',
    background: `
      radial-gradient(circle at 20% 60%, ${styleColors.lavenderAlpha20} 20%, ${styleColors.transparent} 64%),
      radial-gradient(circle at 80% 40%, ${styleColors.neonPurpleAlpha20} 22%, ${styleColors.transparent} 64%),
      linear-gradient(90deg, ${styleColors.neonPurple} 0%, ${styleColors.vividPurple} 100%)
    `,
    backgroundSize: '200% 200%',
    border: `2px solid ${styleColors.neonPurple}`,
    animation: '$subtleNeonBorder 2.2s linear infinite, $blobMove 4.2s ease-in-out infinite',
    boxShadow: `0 0 8px 2px ${styleColors.neonPurpleAlpha33}`,
    textShadow: `0 0 4px ${styleColors.neonPurpleAlpha33}`,
  },

  '@keyframes subtleNeonBorder': {
    '0%': {
      borderColor: styleColors.neonPurple,
      boxShadow: `0 0 4px ${styleColors.neonPurpleAlpha33}, 0 0 10px ${styleColors.vividPurpleAlpha13}`,
    },
    '50%': {
      borderColor: styleColors.vividPurple,
      boxShadow: `0 0 10px ${styleColors.neonPurpleAlpha27}, 0 0 16px ${styleColors.vividPurpleAlpha13}`,
    },
    '100%': {
      borderColor: styleColors.neonPurple,
      boxShadow: `0 0 4px ${styleColors.neonPurpleAlpha33}, 0 0 10px ${styleColors.vividPurpleAlpha13}`,
    },
  },

  '@keyframes blobMove': {
    '0%':   { backgroundPosition: '0% 50%, 100% 50%, 0% 0%' },
    '50%':  { backgroundPosition: '100% 50%, 0% 50%, 100% 100%' },
    '100%': { backgroundPosition: '0% 50%, 100% 50%, 0% 0%' },
  },
  aiSelectFAB : {
      minWidth: 'auto',
      width: 'auto',
      maxWidth: '140px',
      borderRadius: '16px',
      alignItems: 'flex-start',
      padding: '8px',
      maxHeight: '200px',
      height: 'auto',
    },
    aiSelectInner : {
      minWidth: '10px',
      maxWidth: '200px',
      alignItems: 'flex-start',
      maxHeight: '120px',
      height: 'auto',
      gap: '8px',
    },
    aiSelectButton : {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px',
    },
    aiText : {
      fontSize: '16px',
      fontWeight: 500,
    },
    skeletonBorder: {
      position: 'relative',
      background: styleColors.greyLight2,
      borderRadius: 4,
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        borderRadius: 4,
        padding: 2,
        background:
          `linear-gradient(120deg, ${styleColors.greyLight3} 25%, ${styleColors.greyLight2} 50%, ${styleColors.greyLight3} 75%)`,
        backgroundSize: '200% 200%',
        animation: '$borderShimmer 1.2s linear infinite',
        WebkitMask:
          `linear-gradient(${styleColors.white} 0 0) content-box, linear-gradient(${styleColors.white} 0 0)`,
        WebkitMaskComposite: 'xor',
        maskComposite: 'exclude',
        pointerEvents: 'none',
        zIndex: 1,
      },
      // ensure content is above the border
      '& > *': {
        position: 'relative',
        zIndex: 2,
      },
    },
    '@keyframes borderShimmer': {
      to: {
        backgroundPosition: '200% 0',
      },
    },
    skeletonBorderRound: {
      borderRadius: 999,
      '&::before': {
        borderRadius: 999,
      },
    },
});



// WEBPACK FOOTER //
// ./src/components/sharednotes/sharednote.style.ts